import { render } from "./paneOne.vue?vue&type=template&id=6148929c&scoped=true"
import script from "./paneOne.vue?vue&type=script&lang=js"
export * from "./paneOne.vue?vue&type=script&lang=js"

import "./paneOne.vue?vue&type=style&index=0&id=6148929c&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6148929c"]])

export default __exports__